import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "../../services/firebaseConnection";
import { useAuth } from "../../context/AuthContext";
import {
  collection,
  addDoc,
  doc,
  setDoc,
  getDocs,
  query,
  where,
  limit,
  getDoc,
  updateDoc,
  deleteDoc,
  writeBatch,
} from "firebase/firestore";

import turn from "../../assets/icons/box-main/icon-home.png";
import "./inclusao.css";

const TIPOS_TREINAMENTO = ["OBRIGATORIO", "EVENTUAL"];
const SITUACOES_TREINAMENTO = ["ATIVO", "DESATIVADO"];

const estadoColaboradorInicial = {
  nome: "",
  cpf: "",
  funcao: "",
  obra: "",
  situacao: "ATIVO",
};

const estadoTreinamentoInicial = {
  nome: "",
  validade: "",
  funcaoBusca: "",
  possuiVencimento: true,
  tipoPadrao: "OBRIGATORIO",
  matrizesSelecionadas: [],
};

const estadoEdicaoTreinamentoInicial = {
  busca: "",
  id: "",
  nomeOriginal: "",
  nome: "",
  validade: "",
  validadeOriginal: "",
  funcaoBusca: "",
  possuiVencimento: true,
  possuiVencimentoOriginal: true,
  tipoPadrao: "OBRIGATORIO",
  matrizesSelecionadas: [],
  matrizesOrigem: [],
  funcoesOriginais: [],
};

const estadoTreinamentoMatrizInicial = {
  id: "",
  nomeOriginal: "",
  nome: "",
  validade: "",
  validadeOriginal: "",
  funcaoBusca: "",
  possuiVencimento: true,
  possuiVencimentoOriginal: true,
  tipoPadrao: "OBRIGATORIO",
  situacao: "ATIVO",
  ativo: true,
  funcoesOriginais: [],
};

const normalizarDigitacao = (texto = "") =>
  String(texto || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toUpperCase();

const normalizarTexto = (texto = "") =>
  String(texto || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .replace(/\s+/g, " ")
    .toUpperCase();

const limparCPF = (valor = "") => String(valor || "").replace(/\D/g, "");

const limparCacheValidadeTreinamentos = () => {
  try {
    Object.keys(sessionStorage || {}).forEach((chave) => {
      if (
        chave.startsWith("treinamentos_") ||
        chave.startsWith("esperados_")
      ) {
        sessionStorage.removeItem(chave);
      }
    });
  } catch {
    // Cache em sessao nao deve impedir a atualizacao principal.
  }
};

const formatarCPF = (valor = "") => {
  const numeros = limparCPF(valor).slice(0, 11);

  if (numeros.length <= 3) return numeros;
  if (numeros.length <= 6) return numeros.replace(/(\d{3})(\d+)/, "$1.$2");
  if (numeros.length <= 9) {
    return numeros.replace(/(\d{3})(\d{3})(\d+)/, "$1.$2.$3");
  }

  return numeros.replace(/(\d{3})(\d{3})(\d{3})(\d{0,2})/, "$1.$2.$3-$4");
};

const limitarValidade = (valor = "") => {
  const somenteNumeros = String(valor || "").replace(/\D/g, "");
  if (!somenteNumeros) return "";

  let numero = Number(somenteNumeros);
  if (numero < 1) numero = 1;
  if (numero > 60) numero = 60;

  return String(numero);
};

const ehMatrizAtlas = (valor = "") =>
  normalizarTexto(valor).replace(/_/g, " ") === "MATRIZ ATLAS";

const Inclusao = () => {
  const navigate = useNavigate();
  const { usuarioLogado } = useAuth();

  const [abaAtiva, setAbaAtiva] = useState("colaborador");
  const [loading, setLoading] = useState(false);
  const [carregandoConfiguracoes, setCarregandoConfiguracoes] = useState(true);
  const [podeCadastrarTreinamento, setPodeCadastrarTreinamento] =
    useState(false);
  const [podeEditarMatrizes, setPodeEditarMatrizes] = useState(false);

  const [obrasDisponiveis, setObrasDisponiveis] = useState([]);
  const [funcoesDisponiveis, setFuncoesDisponiveis] = useState([]);
  const [matrizesDisponiveis, setMatrizesDisponiveis] = useState([]);
  const [treinamentosCatalogo, setTreinamentosCatalogo] = useState([]);
  const [colaboradoresDisponiveis, setColaboradoresDisponiveis] = useState([]);

  const [colaborador, setColaborador] = useState(estadoColaboradorInicial);
  const [treinamento, setTreinamento] = useState(estadoTreinamentoInicial);
  const [funcoesTreinamento, setFuncoesTreinamento] = useState([]);

  const [controleSituacao, setControleSituacao] = useState({
    busca: "",
    id: "",
    nome: "",
    cpf: "",
    funcao: "",
    obra: "",
    situacao: "ATIVO",
    situacaoOriginal: "ATIVO",
  });

  const [edicaoColaborador, setEdicaoColaborador] = useState({
    busca: "",
    id: "",
    nome: "",
    cpf: "",
    funcao: "",
    obra: "",
    situacao: "ATIVO",
    nomeOriginal: "",
    funcaoOriginal: "",
    obraOriginal: "",
    situacaoOriginal: "ATIVO",
  });

  const [edicaoTreinamento, setEdicaoTreinamento] = useState(
    estadoEdicaoTreinamentoInicial,
  );
  const [funcoesTreinamentoEdicao, setFuncoesTreinamentoEdicao] = useState([]);

  const [matrizSelecionada, setMatrizSelecionada] = useState("");
  const [treinamentosMatriz, setTreinamentosMatriz] = useState([]);
  const [treinamentoMatriz, setTreinamentoMatriz] = useState(
    estadoTreinamentoMatrizInicial,
  );
  const [funcoesTreinamentoMatriz, setFuncoesTreinamentoMatriz] = useState([]);

  const [mostrarSugestoesFuncao, setMostrarSugestoesFuncao] = useState(false);
  const [mostrarSugestoesFuncaoEdicao, setMostrarSugestoesFuncaoEdicao] =
    useState(false);
  const [
    mostrarSugestoesFuncaoTreinamento,
    setMostrarSugestoesFuncaoTreinamento,
  ] = useState(false);
  const [
    mostrarSugestoesFuncaoTreinamentoEdicao,
    setMostrarSugestoesFuncaoTreinamentoEdicao,
  ] = useState(false);
  const [mostrarSugestoesFuncaoMatriz, setMostrarSugestoesFuncaoMatriz] =
    useState(false);
  const [
    mostrarSugestoesColaboradorSituacao,
    setMostrarSugestoesColaboradorSituacao,
  ] = useState(false);
  const [
    mostrarSugestoesColaboradorEdicao,
    setMostrarSugestoesColaboradorEdicao,
  ] = useState(false);
  const [
    mostrarSugestoesTreinamentoEdicao,
    setMostrarSugestoesTreinamentoEdicao,
  ] = useState(false);

  const responsavelSistema = () => ({
    nome: normalizarTexto(usuarioLogado?.nome || "NÃO INFORMADO"),
    id: usuarioLogado?.id || usuarioLogado?.cpf || "",
  });

  const criarAuditoria = async ({ acao, entidade, entidadeId, detalhes }) => {
    try {
      const responsavel = responsavelSistema();

      await addDoc(collection(db, "auditoria_sistema"), {
        acao: normalizarTexto(acao),
        entidade: normalizarTexto(entidade),
        entidadeId: normalizarTexto(entidadeId),
        detalhes,
        responsavelNome: responsavel.nome,
        responsavelId: responsavel.id,
        dataHora: new Date().toISOString(),
      });
    } catch (error) {
      console.error("Erro ao registrar auditoria:", error);
    }
  };

  const registrarHistoricoColaborador = async ({
    colaboradorId,
    tipo,
    dadosAnteriores,
    dadosNovos,
  }) => {
    try {
      const responsavel = responsavelSistema();

      await addDoc(
        collection(db, "funcionarios", colaboradorId, "historico_alteracoes"),
        {
          tipo: normalizarTexto(tipo),
          dadosAnteriores,
          dadosNovos,
          responsavelNome: responsavel.nome,
          responsavelId: responsavel.id,
          dataMudanca: new Date().toISOString(),
        },
      );
    } catch (error) {
      console.error("Erro ao registrar histórico:", error);
    }
  };

  const buscarPermissaoUsuario = useCallback(async () => {
    try {
      if (!usuarioLogado?.cpf) {
        setPodeCadastrarTreinamento(false);
        setPodeEditarMatrizes(false);
        return;
      }

      const q = query(
        collection(db, "administradores"),
        where("cpf", "==", usuarioLogado.cpf),
        limit(1),
      );

      const snapshot = await getDocs(q);

      if (snapshot.empty) {
        setPodeCadastrarTreinamento(false);
        setPodeEditarMatrizes(false);
        return;
      }

      const dadosAdmin = snapshot.docs[0].data();
      const modificar =
        String(dadosAdmin.modificar || "").toUpperCase() === "VERDADEIRO" ||
        dadosAdmin.modificar === true;
      const modificarMatriz =
        String(dadosAdmin.modificarMatriz || "").toUpperCase() ===
          "VERDADEIRO" || dadosAdmin.modificarMatriz === true;
      const editarMatrizes =
        String(dadosAdmin.editarMatrizes || "").toUpperCase() ===
          "VERDADEIRO" || dadosAdmin.editarMatrizes === true;

      setPodeCadastrarTreinamento(modificar || modificarMatriz);
      setPodeEditarMatrizes(modificarMatriz || editarMatrizes);
    } catch (error) {
      console.error("Erro ao buscar permissão:", error);
      setPodeCadastrarTreinamento(false);
      setPodeEditarMatrizes(false);
    }
  }, [usuarioLogado]);

  const buscarObras = useCallback(async () => {
    try {
      const snapshot = await getDocs(collection(db, "obras_atuais"));
      const lista = snapshot.docs
        .map((docItem) => ({ id: docItem.id, ...docItem.data() }))
        .filter((obra) => obra.nome && obra.ativa !== false)
        .map((obra) => ({ ...obra, nome: normalizarTexto(obra.nome) }))
        .sort((a, b) => a.nome.localeCompare(b.nome, "pt-BR"));

      setObrasDisponiveis(lista);
    } catch (error) {
      console.error("Erro ao buscar obras:", error);
      setObrasDisponiveis([]);
    }
  }, []);

  const buscarFuncoes = useCallback(async () => {
    try {
      const snapshot = await getDocs(collection(db, "catalogo_funcoes"));
      const lista = snapshot.docs
        .map((docItem) => ({ id: docItem.id, ...docItem.data() }))
        .filter((funcao) => funcao.nome)
        .map((funcao) => ({ ...funcao, nome: normalizarTexto(funcao.nome) }))
        .sort((a, b) => a.nome.localeCompare(b.nome, "pt-BR"));

      setFuncoesDisponiveis(lista);
    } catch (error) {
      console.error("Erro ao buscar funções:", error);
      setFuncoesDisponiveis([]);
    }
  }, []);

  const buscarMatrizes = useCallback(async () => {
    try {
      const snapshot = await getDocs(collection(db, "matrizes"));
      const lista = snapshot.docs
        .map((docItem) => ({ id: docItem.id, ...docItem.data() }))
        .map((matriz) => ({
          ...matriz,
          nome: normalizarTexto(matriz.nome || matriz.id),
        }))
        .sort((a, b) => a.nome.localeCompare(b.nome, "pt-BR"));

      setMatrizesDisponiveis(lista);
    } catch (error) {
      console.error("Erro ao buscar matrizes:", error);
      setMatrizesDisponiveis([]);
    }
  }, []);

  const buscarColaboradores = useCallback(async () => {
    try {
      const snapshot = await getDocs(collection(db, "funcionarios"));
      const lista = snapshot.docs
        .map((docItem) => ({ id: docItem.id, ...docItem.data() }))
        .filter((item) => item.nome)
        .map((item) => ({
          ...item,
          nome: normalizarTexto(item.nome),
          funcao: normalizarTexto(item.funcao),
          obra: normalizarTexto(item.obra),
          situacao: normalizarTexto(item.situacao || "ATIVO"),
        }))
        .sort((a, b) => a.nome.localeCompare(b.nome, "pt-BR"));

      setColaboradoresDisponiveis(lista);
    } catch (error) {
      console.error("Erro ao buscar colaboradores:", error);
      setColaboradoresDisponiveis([]);
    }
  }, []);

  const montarTreinamentoCatalogo = useCallback((treinamentoDoc, matrizId) => {
    const dados = treinamentoDoc.data();
    const nome = normalizarTexto(dados.nome || treinamentoDoc.id);
    const funcoesVinculadas = Array.isArray(dados.funcoesVinculadas)
      ? dados.funcoesVinculadas.map((item) => ({
          funcao: normalizarTexto(item.funcao || ""),
          tipo: normalizarTexto(
            item.tipo || dados.tipoPadrao || dados.tipo || "OBRIGATORIO",
          ),
        }))
      : [];

    return {
      id: nome,
      nome,
      validade: dados.validade || "",
      possuiVencimento:
        dados.possuiVencimento !== undefined
          ? Boolean(dados.possuiVencimento)
          : Boolean(dados.validade),
      tipoPadrao: normalizarTexto(
        dados.tipoPadrao || dados.tipo || "OBRIGATORIO",
      ),
      funcoesVinculadas,
      matrizesOrigem: [matrizId],
      ativo: dados.ativo !== false,
      situacao: dados.ativo === false ? "DESATIVADO" : "ATIVO",
    };
  }, []);

  const buscarTreinamentosCatalogo = useCallback(async () => {
    try {
      const matrizesSnapshot = await getDocs(collection(db, "matrizes"));
      const mapaTreinamentos = new Map();

      for (const matrizDoc of matrizesSnapshot.docs) {
        const matrizId = matrizDoc.id;
        const treinamentosSnapshot = await getDocs(
          collection(db, "matrizes", matrizId, "treinamentos"),
        );

        treinamentosSnapshot.docs.forEach((treinamentoDoc) => {
          const novo = montarTreinamentoCatalogo(treinamentoDoc, matrizId);

          if (!mapaTreinamentos.has(novo.nome)) {
            mapaTreinamentos.set(novo.nome, novo);
            return;
          }

          const existente = mapaTreinamentos.get(novo.nome);
          if (!existente.matrizesOrigem.includes(matrizId)) {
            existente.matrizesOrigem.push(matrizId);
          }

          novo.funcoesVinculadas.forEach((funcaoNova) => {
            const jaExiste = existente.funcoesVinculadas.some(
              (funcaoAtual) => funcaoAtual.funcao === funcaoNova.funcao,
            );

            if (!jaExiste && funcaoNova.funcao) {
              existente.funcoesVinculadas.push(funcaoNova);
            }
          });
        });
      }

      setTreinamentosCatalogo(
        Array.from(mapaTreinamentos.values()).sort((a, b) =>
          a.nome.localeCompare(b.nome, "pt-BR"),
        ),
      );
    } catch (error) {
      console.error("Erro ao buscar treinamentos nas matrizes:", error);
      setTreinamentosCatalogo([]);
    }
  }, [montarTreinamentoCatalogo]);

  const buscarTreinamentosDaMatriz = useCallback(async (matrizId) => {
    try {
      if (!matrizId) {
        setTreinamentosMatriz([]);
        return;
      }

      const snapshot = await getDocs(
        collection(db, "matrizes", matrizId, "treinamentos"),
      );

      const lista = snapshot.docs
        .map((docItem) => {
          const dados = docItem.data();
          return {
            id: docItem.id,
            ...dados,
            nome: normalizarTexto(dados.nome || docItem.id),
            tipoPadrao: normalizarTexto(
              dados.tipoPadrao || dados.tipo || "OBRIGATORIO",
            ),
            situacao: dados.ativo === false ? "DESATIVADO" : "ATIVO",
            ativo: dados.ativo !== false,
          };
        })
        .sort((a, b) => a.nome.localeCompare(b.nome, "pt-BR"));

      setTreinamentosMatriz(lista);
    } catch (error) {
      console.error("Erro ao buscar treinamentos da matriz:", error);
      setTreinamentosMatriz([]);
    }
  }, []);

  useEffect(() => {
    async function carregarConfiguracoes() {
      try {
        setCarregandoConfiguracoes(true);
        await Promise.all([
          buscarPermissaoUsuario(),
          buscarObras(),
          buscarFuncoes(),
          buscarMatrizes(),
          buscarColaboradores(),
          buscarTreinamentosCatalogo(),
        ]);
      } finally {
        setCarregandoConfiguracoes(false);
      }
    }

    carregarConfiguracoes();
  }, [
    buscarPermissaoUsuario,
    buscarObras,
    buscarFuncoes,
    buscarMatrizes,
    buscarColaboradores,
    buscarTreinamentosCatalogo,
  ]);

  useEffect(() => {
    if (!podeCadastrarTreinamento && abaAtiva === "treinamento") {
      setAbaAtiva("colaborador");
    }

    if (!podeEditarMatrizes && abaAtiva === "matrizes") {
      setAbaAtiva("colaborador");
    }
  }, [podeCadastrarTreinamento, podeEditarMatrizes, abaAtiva]);

  useEffect(() => {
    if (matrizSelecionada) {
      buscarTreinamentosDaMatriz(matrizSelecionada);
    } else {
      setTreinamentosMatriz([]);
    }

    setTreinamentoMatriz(estadoTreinamentoMatrizInicial);
    setFuncoesTreinamentoMatriz([]);
  }, [matrizSelecionada, buscarTreinamentosDaMatriz]);

  const filtrarFuncoes = (textoBusca, listaAtual) => {
    const texto = normalizarTexto(textoBusca).toLowerCase();
    if (!texto) return [];

    return funcoesDisponiveis.filter((funcao) => {
      const jaSelecionada = listaAtual.some(
        (item) => normalizarTexto(item.funcao) === normalizarTexto(funcao.nome),
      );

      return !jaSelecionada && funcao.nome.toLowerCase().includes(texto);
    });
  };

  const textoSugestaoFuncao = normalizarTexto(colaborador.funcao).toLowerCase();
  const sugestoesFuncoes = textoSugestaoFuncao
    ? funcoesDisponiveis.filter((funcao) =>
        funcao.nome.toLowerCase().includes(textoSugestaoFuncao),
      )
    : [];

  const textoSugestaoFuncaoEdicao = normalizarTexto(
    edicaoColaborador.funcao,
  ).toLowerCase();
  const sugestoesFuncoesEdicao = textoSugestaoFuncaoEdicao
    ? funcoesDisponiveis.filter((funcao) =>
        funcao.nome.toLowerCase().includes(textoSugestaoFuncaoEdicao),
      )
    : [];

  const sugestoesFuncoesTreinamento = filtrarFuncoes(
    treinamento.funcaoBusca,
    funcoesTreinamento,
  );

  const sugestoesFuncoesTreinamentoEdicao = filtrarFuncoes(
    edicaoTreinamento.funcaoBusca,
    funcoesTreinamentoEdicao,
  );

  const sugestoesFuncoesMatriz = filtrarFuncoes(
    treinamentoMatriz.funcaoBusca,
    funcoesTreinamentoMatriz,
  );

  const textoSituacao = normalizarTexto(controleSituacao.busca).toLowerCase();
  const sugestoesColaboradorSituacao = textoSituacao
    ? colaboradoresDisponiveis.filter((item) => {
        const nome = item.nome.toLowerCase();
        const cpf = formatarCPF(item.cpf || "").toLowerCase();
        const cpfLimpo = limparCPF(item.cpf || "");
        return (
          nome.includes(textoSituacao) ||
          cpf.includes(textoSituacao) ||
          cpfLimpo.includes(textoSituacao)
        );
      })
    : [];

  const textoEdicaoColaborador = normalizarTexto(
    edicaoColaborador.busca,
  ).toLowerCase();
  const sugestoesColaboradorEdicao = textoEdicaoColaborador
    ? colaboradoresDisponiveis.filter((item) => {
        const nome = item.nome.toLowerCase();
        const cpf = formatarCPF(item.cpf || "").toLowerCase();
        const cpfLimpo = limparCPF(item.cpf || "");
        return (
          nome.includes(textoEdicaoColaborador) ||
          cpf.includes(textoEdicaoColaborador) ||
          cpfLimpo.includes(textoEdicaoColaborador)
        );
      })
    : [];

  const textoTreinamentoEdicao = normalizarTexto(
    edicaoTreinamento.busca,
  ).toLowerCase();
  const sugestoesTreinamentoEdicao = textoTreinamentoEdicao
    ? treinamentosCatalogo.filter((item) =>
        item.nome.toLowerCase().includes(textoTreinamentoEdicao),
      )
    : [];

  const handleCpfChange = (e) => {
    setColaborador((prev) => ({ ...prev, cpf: formatarCPF(e.target.value) }));
  };

  const handleColaboradorChange = (e) => {
    const { name, value } = e.target;
    setColaborador((prev) => ({
      ...prev,
      [name]:
        name === "nome" || name === "funcao"
          ? normalizarDigitacao(value)
          : normalizarTexto(value),
    }));
  };

  const handleEdicaoColaboradorChange = (e) => {
    const { name, value } = e.target;
    setEdicaoColaborador((prev) => ({
      ...prev,
      [name]: ["busca", "nome", "funcao"].includes(name)
        ? normalizarDigitacao(value)
        : normalizarTexto(value),
    }));
  };

  const handleControleSituacaoChange = (e) => {
    const { name, value } = e.target;
    setControleSituacao((prev) => ({
      ...prev,
      [name]:
        name === "busca" ? normalizarDigitacao(value) : normalizarTexto(value),
    }));
  };

  const handleTreinamentoChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === "validade") {
      setTreinamento((prev) => ({ ...prev, validade: limitarValidade(value) }));
      return;
    }

    if (type === "checkbox") {
      if (name === "possuiVencimento") {
        setTreinamento((prev) => ({
          ...prev,
          possuiVencimento: checked,
          validade: checked ? prev.validade : "",
        }));
        return;
      }

      if (name === "matrizesSelecionadas") {
        setTreinamento((prev) => {
          const matrizClicadaEhAtlas = ehMatrizAtlas(value);

          const matrizesSelecionadas = checked
            ? matrizClicadaEhAtlas
              ? [value]
              : [
                  ...prev.matrizesSelecionadas.filter(
                    (matriz) => !ehMatrizAtlas(matriz),
                  ),
                  value,
                ]
            : prev.matrizesSelecionadas.filter((matriz) => matriz !== value);

          return {
            ...prev,
            matrizesSelecionadas,
          };
        });
        return;
      }
    }

    setTreinamento((prev) => ({
      ...prev,
      [name]:
        name === "nome" || name === "funcaoBusca"
          ? normalizarDigitacao(value)
          : normalizarTexto(value),
    }));
  };

  const handleTreinamentoEdicaoChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === "validade") {
      setEdicaoTreinamento((prev) => ({
        ...prev,
        validade: limitarValidade(value),
      }));
      return;
    }

    if (type === "checkbox") {
      if (name === "possuiVencimento") {
        setEdicaoTreinamento((prev) => ({
          ...prev,
          possuiVencimento: checked,
          validade: checked ? prev.validade : "",
        }));
        return;
      }

      if (name === "matrizesSelecionadas") {
        setEdicaoTreinamento((prev) => {
          const matrizClicadaEhAtlas = ehMatrizAtlas(value);

          const matrizesSelecionadas = checked
            ? matrizClicadaEhAtlas
              ? [value]
              : [
                  ...prev.matrizesSelecionadas.filter(
                    (matriz) => !ehMatrizAtlas(matriz),
                  ),
                  value,
                ]
            : prev.matrizesSelecionadas.filter((matriz) => matriz !== value);

          return {
            ...prev,
            matrizesSelecionadas,
          };
        });
        return;
      }
    }

    setEdicaoTreinamento((prev) => ({
      ...prev,
      [name]: ["nome", "busca", "funcaoBusca"].includes(name)
        ? normalizarDigitacao(value)
        : normalizarTexto(value),
    }));
  };

  const handleTreinamentoMatrizChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === "validade") {
      setTreinamentoMatriz((prev) => ({
        ...prev,
        validade: limitarValidade(value),
      }));
      return;
    }

    if (type === "checkbox" && name === "possuiVencimento") {
      setTreinamentoMatriz((prev) => ({
        ...prev,
        possuiVencimento: checked,
        validade: checked ? prev.validade : "",
      }));
      return;
    }

    if (name === "situacao") {
      setTreinamentoMatriz((prev) => ({
        ...prev,
        situacao: normalizarTexto(value),
        ativo: normalizarTexto(value) === "ATIVO",
      }));
      return;
    }

    setTreinamentoMatriz((prev) => ({
      ...prev,
      [name]: ["nome", "funcaoBusca"].includes(name)
        ? normalizarDigitacao(value)
        : normalizarTexto(value),
    }));
  };

  const funcaoValida = (funcaoDigitada) => {
    const funcaoNormalizada = normalizarTexto(funcaoDigitada);
    return funcoesDisponiveis.some(
      (funcao) => normalizarTexto(funcao.nome) === funcaoNormalizada,
    );
  };

  const selecionarFuncao = (nomeFuncao) => {
    setColaborador((prev) => ({
      ...prev,
      funcao: normalizarTexto(nomeFuncao),
    }));
    setMostrarSugestoesFuncao(false);
  };

  const selecionarFuncaoEdicao = (nomeFuncao) => {
    setEdicaoColaborador((prev) => ({
      ...prev,
      funcao: normalizarTexto(nomeFuncao),
    }));
    setMostrarSugestoesFuncaoEdicao(false);
  };

  const adicionarFuncaoEmLista = (setLista, nomeFuncao, tipoPadrao) => {
    const funcao = normalizarTexto(nomeFuncao);
    if (!funcao) return;

    setLista((prev) => {
      const jaExiste = prev.some(
        (item) => normalizarTexto(item.funcao) === funcao,
      );
      if (jaExiste) return prev;
      return [
        ...prev,
        { funcao, tipo: normalizarTexto(tipoPadrao || "OBRIGATORIO") },
      ];
    });
  };

  const selecionarFuncaoTreinamento = (nomeFuncao) => {
    adicionarFuncaoEmLista(
      setFuncoesTreinamento,
      nomeFuncao,
      treinamento.tipoPadrao,
    );
    setTreinamento((prev) => ({ ...prev, funcaoBusca: "" }));
    setMostrarSugestoesFuncaoTreinamento(false);
  };

  const selecionarFuncaoTreinamentoEdicao = (nomeFuncao) => {
    adicionarFuncaoEmLista(
      setFuncoesTreinamentoEdicao,
      nomeFuncao,
      edicaoTreinamento.tipoPadrao,
    );
    setEdicaoTreinamento((prev) => ({ ...prev, funcaoBusca: "" }));
    setMostrarSugestoesFuncaoTreinamentoEdicao(false);
  };

  const selecionarFuncaoMatriz = (nomeFuncao) => {
    adicionarFuncaoEmLista(
      setFuncoesTreinamentoMatriz,
      nomeFuncao,
      treinamentoMatriz.tipoPadrao,
    );
    setTreinamentoMatriz((prev) => ({ ...prev, funcaoBusca: "" }));
    setMostrarSugestoesFuncaoMatriz(false);
  };

  const selecionarTodasFuncoesCriacao = () => {
    setFuncoesTreinamento(
      funcoesDisponiveis.map((funcao) => ({
        funcao: normalizarTexto(funcao.nome),
        tipo: normalizarTexto(treinamento.tipoPadrao),
      })),
    );
    setTreinamento((prev) => ({ ...prev, funcaoBusca: "" }));
  };

  const selecionarTodasFuncoesEdicao = () => {
    setFuncoesTreinamentoEdicao(
      funcoesDisponiveis.map((funcao) => ({
        funcao: normalizarTexto(funcao.nome),
        tipo: normalizarTexto(edicaoTreinamento.tipoPadrao),
      })),
    );
    setEdicaoTreinamento((prev) => ({ ...prev, funcaoBusca: "" }));
  };

  const selecionarTodasFuncoesMatriz = () => {
    setFuncoesTreinamentoMatriz(
      funcoesDisponiveis.map((funcao) => ({
        funcao: normalizarTexto(funcao.nome),
        tipo: normalizarTexto(treinamentoMatriz.tipoPadrao),
      })),
    );
    setTreinamentoMatriz((prev) => ({ ...prev, funcaoBusca: "" }));
  };

  const alterarTipoFuncao = (setLista, index, novoTipo) => {
    setLista((prev) =>
      prev.map((item, i) =>
        i === index ? { ...item, tipo: normalizarTexto(novoTipo) } : item,
      ),
    );
  };

  const removerFuncao = (setLista, index) => {
    setLista((prev) => prev.filter((_, i) => i !== index));
  };

  const selecionarColaboradorSituacao = (item) => {
    setControleSituacao({
      busca: item.nome || "",
      id: item.id || "",
      nome: item.nome || "",
      cpf: formatarCPF(item.cpf || ""),
      funcao: item.funcao || "",
      obra: item.obra || "",
      situacao: item.situacao || "ATIVO",
      situacaoOriginal: item.situacao || "ATIVO",
    });
    setMostrarSugestoesColaboradorSituacao(false);
  };

  const selecionarColaboradorEdicao = (item) => {
    setEdicaoColaborador({
      busca: item.nome || "",
      id: item.id || "",
      nome: item.nome || "",
      cpf: formatarCPF(item.cpf || ""),
      funcao: item.funcao || "",
      obra: item.obra || "",
      situacao: item.situacao || "ATIVO",
      nomeOriginal: item.nome || "",
      funcaoOriginal: item.funcao || "",
      obraOriginal: item.obra || "",
      situacaoOriginal: item.situacao || "ATIVO",
    });
    setMostrarSugestoesColaboradorEdicao(false);
  };

  const selecionarTreinamentoEdicao = (item) => {
    const funcoesOriginais = Array.isArray(item.funcoesVinculadas)
      ? item.funcoesVinculadas.map((funcao) => ({
          funcao: normalizarTexto(funcao.funcao || ""),
          tipo: normalizarTexto(funcao.tipo || "OBRIGATORIO"),
        }))
      : [];

    setEdicaoTreinamento({
      busca: item.nome || "",
      id: item.nome || "",
      nomeOriginal: item.nome || "",
      nome: item.nome || "",
      validade: item.validade || "",
      validadeOriginal: item.validade || "",
      funcaoBusca: "",
      possuiVencimento:
        item.possuiVencimento !== undefined
          ? Boolean(item.possuiVencimento)
          : Boolean(item.validade),
      possuiVencimentoOriginal:
        item.possuiVencimento !== undefined
          ? Boolean(item.possuiVencimento)
          : Boolean(item.validade),
      tipoPadrao: normalizarTexto(item.tipoPadrao || "OBRIGATORIO"),
      matrizesSelecionadas: item.matrizesOrigem || [],
      matrizesOrigem: item.matrizesOrigem || [],
      funcoesOriginais,
    });
    setFuncoesTreinamentoEdicao(funcoesOriginais);
    setMostrarSugestoesTreinamentoEdicao(false);
  };

  const selecionarTreinamentoDaMatriz = (item) => {
    const funcoesOriginais = Array.isArray(item.funcoesVinculadas)
      ? item.funcoesVinculadas.map((funcao) => ({
          funcao: normalizarTexto(funcao.funcao || ""),
          tipo: normalizarTexto(
            funcao.tipo || item.tipoPadrao || item.tipo || "OBRIGATORIO",
          ),
        }))
      : [];

    setTreinamentoMatriz({
      id: item.id,
      nomeOriginal: normalizarTexto(item.nome || item.id),
      nome: normalizarTexto(item.nome || item.id),
      validade: item.validade || "",
      validadeOriginal: item.validade || "",
      funcaoBusca: "",
      possuiVencimento:
        item.possuiVencimento !== undefined
          ? Boolean(item.possuiVencimento)
          : Boolean(item.validade),
      possuiVencimentoOriginal:
        item.possuiVencimento !== undefined
          ? Boolean(item.possuiVencimento)
          : Boolean(item.validade),
      tipoPadrao: normalizarTexto(
        item.tipoPadrao || item.tipo || "OBRIGATORIO",
      ),
      situacao: item.ativo === false ? "DESATIVADO" : "ATIVO",
      ativo: item.ativo !== false,
      funcoesOriginais,
    });
    setFuncoesTreinamentoMatriz(funcoesOriginais);
  };

  const limparControleSituacao = () => {
    setControleSituacao({
      busca: "",
      id: "",
      nome: "",
      cpf: "",
      funcao: "",
      obra: "",
      situacao: "ATIVO",
      situacaoOriginal: "ATIVO",
    });
    setMostrarSugestoesColaboradorSituacao(false);
  };

  const limparEdicaoColaborador = () => {
    setEdicaoColaborador({
      busca: "",
      id: "",
      nome: "",
      cpf: "",
      funcao: "",
      obra: "",
      situacao: "ATIVO",
      nomeOriginal: "",
      funcaoOriginal: "",
      obraOriginal: "",
      situacaoOriginal: "ATIVO",
    });
    setMostrarSugestoesColaboradorEdicao(false);
    setMostrarSugestoesFuncaoEdicao(false);
  };

  const limparTreinamento = () => {
    setTreinamento(estadoTreinamentoInicial);
    setFuncoesTreinamento([]);
  };

  const limparEdicaoTreinamento = () => {
    setEdicaoTreinamento(estadoEdicaoTreinamentoInicial);
    setFuncoesTreinamentoEdicao([]);
    setMostrarSugestoesTreinamentoEdicao(false);
    setMostrarSugestoesFuncaoTreinamentoEdicao(false);
  };

  const limparTreinamentoMatriz = () => {
    setTreinamentoMatriz(estadoTreinamentoMatrizInicial);
    setFuncoesTreinamentoMatriz([]);
    setMostrarSugestoesFuncaoMatriz(false);
  };

  const validarTreinamento = ({
    nome,
    validade,
    possuiVencimento,
    funcoes,
    matrizes,
  }) => {
    if (!normalizarTexto(nome)) {
      alert("PREENCHA O NOME DO TREINAMENTO.");
      return false;
    }

    if (Array.isArray(matrizes) && matrizes.length === 0) {
      alert("SELECIONE PELO MENOS UMA MATRIZ PARA ESTE TREINAMENTO.");
      return false;
    }

    if (!Array.isArray(funcoes) || funcoes.length === 0) {
      alert("ADICIONE PELO MENOS UMA FUNÇÃO AO TREINAMENTO.");
      return false;
    }

    const existeFuncaoVazia = funcoes.some(
      (item) => !normalizarTexto(item.funcao),
    );
    if (existeFuncaoVazia) {
      alert("EXISTE UMA FUNÇÃO INVÁLIDA NA LISTA.");
      return false;
    }

    if (possuiVencimento) {
      const validadeNumero = Number(validade);
      if (!validadeNumero || validadeNumero < 1 || validadeNumero > 60) {
        alert("A VALIDADE DEVE SER UM NÚMERO ENTRE 1 E 60 MESES.");
        return false;
      }
    }

    return true;
  };

  const montarDadosTreinamento = ({
    nome,
    tipoPadrao,
    validade,
    possuiVencimento,
    funcoes,
    ativo,
    extras = {},
  }) => ({
    nome: normalizarTexto(nome),
    tipo: normalizarTexto(tipoPadrao),
    tipoPadrao: normalizarTexto(tipoPadrao),
    validade: possuiVencimento ? String(validade) : "",
    possuiVencimento: Boolean(possuiVencimento),
    funcoesVinculadas: funcoes.map((item) => ({
      funcao: normalizarTexto(item.funcao),
      tipo: normalizarTexto(item.tipo || tipoPadrao),
    })),
    ativo: ativo !== false,
    situacao: ativo === false ? "DESATIVADO" : "ATIVO",
    ...extras,
  });

  const removerTreinamentoDasFuncoesMatriz = async ({
    matrizId,
    nomeTreinamento,
    funcoes,
  }) => {
    const funcoesUnicas = [
      ...new Set(
        (funcoes || [])
          .map((item) => normalizarTexto(item.funcao))
          .filter(Boolean),
      ),
    ];

    for (const funcao of funcoesUnicas) {
      await deleteDoc(
        doc(
          db,
          "matrizes",
          matrizId,
          "funcoes",
          funcao,
          "treinamentos",
          nomeTreinamento,
        ),
      );
    }
  };

  const gravarTreinamentoNasFuncoesMatriz = async ({
    matrizId,
    dadosTreinamento,
    responsavel,
    agora,
    modo,
  }) => {
    for (const item of dadosTreinamento.funcoesVinculadas) {
      await setDoc(
        doc(
          db,
          "matrizes",
          matrizId,
          "funcoes",
          item.funcao,
          "treinamentos",
          dadosTreinamento.nome,
        ),
        {
          nome: dadosTreinamento.nome,
          tipo: item.tipo,
          validade: dadosTreinamento.validade,
          possuiVencimento: dadosTreinamento.possuiVencimento,
          matriz: matrizId,
          funcao: item.funcao,
          ativo: dadosTreinamento.ativo,
          situacao: dadosTreinamento.situacao,
          ...(modo === "cadastro"
            ? {
                cadastradoPor: responsavel.nome,
                cadastradoPorId: responsavel.id,
                dataCadastro: agora,
              }
            : {
                atualizadoPor: responsavel.nome,
                atualizadoPorId: responsavel.id,
                dataAtualizacao: agora,
              }),
        },
      );
    }
  };

  const atualizarValidadeLancamentosExistentes = async ({
    nomeTreinamento,
    dadosTreinamento,
    responsavel,
    agora,
  }) => {
    const nomeNormalizado = normalizarTexto(nomeTreinamento);
    if (!nomeNormalizado) return 0;

    const funcionariosSnapshot = await getDocs(collection(db, "funcionarios"));
    const documentosParaAtualizar = [];

    for (const funcionarioDoc of funcionariosSnapshot.docs) {
      const treinamentosSnapshot = await getDocs(
        query(
          collection(db, "funcionarios", funcionarioDoc.id, "treinamentos"),
          where("treinamentoNome", "==", nomeNormalizado),
        ),
      );

      treinamentosSnapshot.docs.forEach((treinamentoDoc) => {
        const dados = treinamentoDoc.data();

        if (
          dados.substituido === true ||
          normalizarTexto(dados.statusLancamento) === "SUBSTITUIDO" ||
          normalizarTexto(dados.situacaoLancamento) === "SUBSTITUIDO"
        ) {
          return;
        }

        documentosParaAtualizar.push(treinamentoDoc.ref);
      });
    }

    for (let i = 0; i < documentosParaAtualizar.length; i += 400) {
      const lote = writeBatch(db);
      const fatia = documentosParaAtualizar.slice(i, i + 400);

      fatia.forEach((treinamentoRef) => {
        lote.update(treinamentoRef, {
          validadeMeses: dadosTreinamento.possuiVencimento
            ? dadosTreinamento.validade
            : "",
          possuiVencimento: dadosTreinamento.possuiVencimento,
          validadeAtualizadaPor: responsavel.nome,
          validadeAtualizadaPorId: responsavel.id,
          dataAtualizacaoValidade: agora,
        });
      });

      await lote.commit();
    }

    return documentosParaAtualizar.length;
  };

  const cadastrarColaborador = async () => {
    const cpfLimpo = limparCPF(colaborador.cpf);
    const nome = normalizarTexto(colaborador.nome);
    const funcao = normalizarTexto(colaborador.funcao);
    const obra = normalizarTexto(colaborador.obra);
    const situacao = "ATIVO";
    const agora = new Date().toISOString();
    const responsavel = responsavelSistema();

    if (!nome || !funcao || !obra) {
      alert("PREENCHA NOME, FUNÇÃO E OBRA CORRETAMENTE.");
      return;
    }

    if (cpfLimpo.length !== 11) {
      alert("O CPF DEVE CONTER EXATAMENTE 11 NÚMEROS.");
      return;
    }

    if (!funcaoValida(funcao)) {
      alert("SELECIONE UMA FUNÇÃO VÁLIDA DA LISTA.");
      return;
    }

    try {
      setLoading(true);

      const funcionarioRef = doc(db, "funcionarios", cpfLimpo);
      const funcionarioExistente = await getDoc(funcionarioRef);

      if (funcionarioExistente.exists()) {
        alert("JÁ EXISTE UM COLABORADOR CADASTRADO COM ESSE CPF.");
        return;
      }

      const qNome = query(
        collection(db, "funcionarios"),
        where("nome", "==", nome),
        limit(1),
      );
      const nomeExistente = await getDocs(qNome);

      if (!nomeExistente.empty) {
        alert("JÁ EXISTE UM COLABORADOR CADASTRADO COM ESSE NOME.");
        return;
      }

      await setDoc(funcionarioRef, {
        nome,
        cpf: cpfLimpo,
        funcao,
        obra,
        situacao,
        cadastradoPor: responsavel.nome,
        cadastradoPorId: responsavel.id,
        dataCadastro: agora,
        atualizadoPor: responsavel.nome,
        atualizadoPorId: responsavel.id,
        dataAtualizacao: agora,
      });

      await registrarHistoricoColaborador({
        colaboradorId: cpfLimpo,
        tipo: "CADASTRO_COLABORADOR",
        dadosAnteriores: null,
        dadosNovos: { nome, cpf: cpfLimpo, funcao, obra, situacao },
      });

      await criarAuditoria({
        acao: "CADASTRO_COLABORADOR",
        entidade: "COLABORADOR",
        entidadeId: cpfLimpo,
        detalhes: { nome, cpf: cpfLimpo, funcao, obra, situacao },
      });

      alert("COLABORADOR CADASTRADO COM SUCESSO!");
      setColaborador(estadoColaboradorInicial);
      setMostrarSugestoesFuncao(false);
      await buscarColaboradores();
    } catch (error) {
      console.error("Erro ao cadastrar colaborador:", error);
      alert("ERRO AO CADASTRAR COLABORADOR.");
    } finally {
      setLoading(false);
    }
  };

  const editarColaborador = async () => {
    if (!edicaoColaborador.id) {
      alert("SELECIONE UM COLABORADOR PARA EDITAR.");
      return;
    }

    const nome = normalizarTexto(edicaoColaborador.nome);
    const funcao = normalizarTexto(edicaoColaborador.funcao);
    const obra = normalizarTexto(edicaoColaborador.obra);
    const situacaoAtual = normalizarTexto(
      edicaoColaborador.situacaoOriginal || "ATIVO",
    );
    const agora = new Date().toISOString();
    const responsavel = responsavelSistema();

    const dadosAnteriores = {
      nome: normalizarTexto(edicaoColaborador.nomeOriginal),
      funcao: normalizarTexto(edicaoColaborador.funcaoOriginal),
      obra: normalizarTexto(edicaoColaborador.obraOriginal),
      situacao: situacaoAtual,
    };

    const dadosNovos = { nome, funcao, obra, situacao: situacaoAtual };
    const mudouNome = dadosAnteriores.nome !== dadosNovos.nome;
    const mudouFuncao = dadosAnteriores.funcao !== dadosNovos.funcao;
    const mudouObra = dadosAnteriores.obra !== dadosNovos.obra;

    if (!nome || !funcao || !obra) {
      alert("PREENCHA NOME, FUNÇÃO E OBRA CORRETAMENTE.");
      return;
    }

    if (!funcaoValida(funcao)) {
      alert("SELECIONE UMA FUNÇÃO VÁLIDA DA LISTA.");
      return;
    }

    if (!mudouNome && !mudouFuncao && !mudouObra) {
      alert("NENHUMA ALTERAÇÃO FOI IDENTIFICADA.");
      return;
    }

    try {
      setLoading(true);

      await updateDoc(doc(db, "funcionarios", edicaoColaborador.id), {
        nome,
        funcao,
        obra,
        atualizadoPor: responsavel.nome,
        atualizadoPorId: responsavel.id,
        dataAtualizacao: agora,
        ...(mudouFuncao
          ? {
              funcaoAlteradaPor: responsavel.nome,
              funcaoAlteradaPorId: responsavel.id,
              dataAlteracaoFuncao: agora,
            }
          : {}),
        ...(mudouObra
          ? {
              obraAlteradaPor: responsavel.nome,
              obraAlteradaPorId: responsavel.id,
              dataAlteracaoObra: agora,
            }
          : {}),
      });

      if (mudouFuncao || mudouObra) {
        await registrarHistoricoColaborador({
          colaboradorId: edicaoColaborador.id,
          tipo: "MUDANCA_OBRA_FUNCAO",
          dadosAnteriores,
          dadosNovos,
        });
      }

      await criarAuditoria({
        acao: "EDICAO_COLABORADOR",
        entidade: "COLABORADOR",
        entidadeId: edicaoColaborador.id,
        detalhes: {
          dadosAnteriores,
          dadosNovos,
          alteracoes: { mudouNome, mudouFuncao, mudouObra },
        },
      });

      alert("COLABORADOR ATUALIZADO COM SUCESSO!");
      limparEdicaoColaborador();
      await buscarColaboradores();
    } catch (error) {
      console.error("Erro ao editar colaborador:", error);
      alert("ERRO AO EDITAR COLABORADOR.");
    } finally {
      setLoading(false);
    }
  };

  const atualizarSituacaoColaborador = async () => {
    if (!controleSituacao.id) {
      alert("SELECIONE UM COLABORADOR PARA ALTERAR A SITUAÇÃO.");
      return;
    }

    const situacao = normalizarTexto(controleSituacao.situacao);
    const situacaoAnterior = normalizarTexto(controleSituacao.situacaoOriginal);
    const agora = new Date().toISOString();
    const responsavel = responsavelSistema();

    if (situacao === situacaoAnterior) {
      alert("A SITUAÇÃO SELECIONADA JÁ É A SITUAÇÃO ATUAL DO COLABORADOR.");
      return;
    }

    try {
      setLoading(true);

      await updateDoc(doc(db, "funcionarios", controleSituacao.id), {
        situacao,
        atualizadoPor: responsavel.nome,
        atualizadoPorId: responsavel.id,
        dataAtualizacao: agora,
        situacaoAlteradaPor: responsavel.nome,
        situacaoAlteradaPorId: responsavel.id,
        dataAlteracaoSituacao: agora,
      });

      await registrarHistoricoColaborador({
        colaboradorId: controleSituacao.id,
        tipo: situacao === "ATIVO" ? "REATIVACAO" : "DESATIVACAO",
        dadosAnteriores: {
          situacao: situacaoAnterior,
          nome: controleSituacao.nome,
          cpf: limparCPF(controleSituacao.cpf),
          funcao: controleSituacao.funcao,
          obra: controleSituacao.obra,
        },
        dadosNovos: {
          situacao,
          nome: controleSituacao.nome,
          cpf: limparCPF(controleSituacao.cpf),
          funcao: controleSituacao.funcao,
          obra: controleSituacao.obra,
        },
      });

      await criarAuditoria({
        acao:
          situacao === "ATIVO"
            ? "REATIVACAO_COLABORADOR"
            : "DESATIVACAO_COLABORADOR",
        entidade: "COLABORADOR",
        entidadeId: controleSituacao.id,
        detalhes: {
          nome: controleSituacao.nome,
          cpf: limparCPF(controleSituacao.cpf),
          situacaoAnterior,
          situacaoNova: situacao,
          funcao: controleSituacao.funcao,
          obra: controleSituacao.obra,
        },
      });

      alert(
        `COLABORADOR ${situacao === "ATIVO" ? "REATIVADO" : "DESATIVADO"} COM SUCESSO!`,
      );
      limparControleSituacao();
      await buscarColaboradores();
    } catch (error) {
      console.error("Erro ao atualizar situação:", error);
      alert("ERRO AO ATUALIZAR SITUAÇÃO DO COLABORADOR.");
    } finally {
      setLoading(false);
    }
  };

  const cadastrarTreinamento = async () => {
    if (!podeCadastrarTreinamento) {
      alert("VOCÊ NÃO TEM PERMISSÃO PARA CADASTRAR TREINAMENTOS.");
      return;
    }

    const nome = normalizarTexto(treinamento.nome);
    const funcoes = funcoesTreinamento.map((item) => ({
      funcao: normalizarTexto(item.funcao),
      tipo: normalizarTexto(item.tipo || treinamento.tipoPadrao),
    }));
    const agora = new Date().toISOString();
    const responsavel = responsavelSistema();

    const valido = validarTreinamento({
      nome,
      validade: treinamento.validade,
      possuiVencimento: treinamento.possuiVencimento,
      funcoes,
      matrizes: treinamento.matrizesSelecionadas,
    });

    if (!valido) return;

    try {
      setLoading(true);

      for (const matrizId of treinamento.matrizesSelecionadas) {
        const treinamentoRef = doc(
          db,
          "matrizes",
          matrizId,
          "treinamentos",
          nome,
        );
        const treinamentoExistente = await getDoc(treinamentoRef);

        if (treinamentoExistente.exists()) {
          alert(`O TREINAMENTO JÁ EXISTE NA MATRIZ: ${matrizId}`);
          return;
        }
      }

      const dadosTreinamento = montarDadosTreinamento({
        nome,
        tipoPadrao: treinamento.tipoPadrao,
        validade: treinamento.validade,
        possuiVencimento: treinamento.possuiVencimento,
        funcoes,
        ativo: true,
        extras: {
          cadastradoPor: responsavel.nome,
          cadastradoPorId: responsavel.id,
          dataCadastro: agora,
        },
      });

      for (const matrizId of treinamento.matrizesSelecionadas) {
        await setDoc(
          doc(db, "matrizes", matrizId, "treinamentos", nome),
          dadosTreinamento,
        );
        await gravarTreinamentoNasFuncoesMatriz({
          matrizId,
          dadosTreinamento,
          responsavel,
          agora,
          modo: "cadastro",
        });
      }

      await criarAuditoria({
        acao: "CADASTRO_TREINAMENTO_MATRIZ",
        entidade: "TREINAMENTO_MATRIZ",
        entidadeId: nome,
        detalhes: {
          nome,
          matrizes: treinamento.matrizesSelecionadas,
          validade: dadosTreinamento.validade,
          possuiVencimento: dadosTreinamento.possuiVencimento,
          tipoPadrao: dadosTreinamento.tipoPadrao,
          funcoesVinculadas: funcoes,
        },
      });

      alert("TREINAMENTO CADASTRADO COM SUCESSO!");
      limparTreinamento();
      await buscarTreinamentosCatalogo();
      if (matrizSelecionada)
        await buscarTreinamentosDaMatriz(matrizSelecionada);
    } catch (error) {
      console.error("Erro ao cadastrar treinamento:", error);
      alert("ERRO AO CADASTRAR TREINAMENTO.");
    } finally {
      setLoading(false);
    }
  };

  const editarTreinamento = async () => {
    if (!edicaoTreinamento.id) {
      alert("SELECIONE UM TREINAMENTO PARA EDITAR.");
      return;
    }

    const nome = normalizarTexto(edicaoTreinamento.nome);
    const nomeOriginal = normalizarTexto(edicaoTreinamento.nomeOriginal);
    const funcoesNovas = funcoesTreinamentoEdicao.map((item) => ({
      funcao: normalizarTexto(item.funcao),
      tipo: normalizarTexto(item.tipo || edicaoTreinamento.tipoPadrao),
    }));
    const agora = new Date().toISOString();
    const responsavel = responsavelSistema();

    const valido = validarTreinamento({
      nome,
      validade: edicaoTreinamento.validade,
      possuiVencimento: edicaoTreinamento.possuiVencimento,
      funcoes: funcoesNovas,
      matrizes: edicaoTreinamento.matrizesSelecionadas,
    });

    if (!valido) return;

    try {
      setLoading(true);

      const matrizesAntigas = edicaoTreinamento.matrizesOrigem || [];
      const matrizesNovas = edicaoTreinamento.matrizesSelecionadas || [];
      const funcoesAntigas = edicaoTreinamento.funcoesOriginais || [];

      const dadosAnteriores = {
        nome: nomeOriginal,
        matrizes: matrizesAntigas,
        validade: edicaoTreinamento.possuiVencimentoOriginal
          ? String(edicaoTreinamento.validadeOriginal)
          : "",
        possuiVencimento: Boolean(edicaoTreinamento.possuiVencimentoOriginal),
        tipoPadrao: normalizarTexto(edicaoTreinamento.tipoPadrao),
        funcoesVinculadas: funcoesAntigas,
      };

      const dadosNovos = montarDadosTreinamento({
        nome,
        tipoPadrao: edicaoTreinamento.tipoPadrao,
        validade: edicaoTreinamento.validade,
        possuiVencimento: edicaoTreinamento.possuiVencimento,
        funcoes: funcoesNovas,
        ativo: true,
        extras: {
          atualizadoPor: responsavel.nome,
          atualizadoPorId: responsavel.id,
          dataAtualizacao: agora,
        },
      });

      for (const matrizId of matrizesAntigas) {
        await deleteDoc(
          doc(db, "matrizes", matrizId, "treinamentos", nomeOriginal),
        );
        await removerTreinamentoDasFuncoesMatriz({
          matrizId,
          nomeTreinamento: nomeOriginal,
          funcoes: funcoesAntigas,
        });
      }

      for (const matrizId of matrizesNovas) {
        await setDoc(
          doc(db, "matrizes", matrizId, "treinamentos", nome),
          dadosNovos,
        );
        await gravarTreinamentoNasFuncoesMatriz({
          matrizId,
          dadosTreinamento: dadosNovos,
          responsavel,
          agora,
          modo: "edicao",
        });
      }

      const mudouValidadeLancamentos =
        dadosAnteriores.validade !== dadosNovos.validade ||
        dadosAnteriores.possuiVencimento !== dadosNovos.possuiVencimento;

      const lancamentosAtualizados =
        await atualizarValidadeLancamentosExistentes({
          nomeTreinamento: nomeOriginal,
          dadosTreinamento: dadosNovos,
          responsavel,
          agora,
        });

      if (lancamentosAtualizados > 0) {
        limparCacheValidadeTreinamentos();
      }

      await criarAuditoria({
        acao: "EDICAO_TREINAMENTO_MATRIZ",
        entidade: "TREINAMENTO_MATRIZ",
        entidadeId: nome,
        detalhes: {
          dadosAnteriores,
          dadosNovos: { ...dadosNovos, matrizes: matrizesNovas },
          alteracoes: {
            mudouNome: nomeOriginal !== nome,
            mudouMatrizes:
              JSON.stringify([...matrizesAntigas].sort()) !==
              JSON.stringify([...matrizesNovas].sort()),
            mudouFuncoes:
              JSON.stringify(funcoesAntigas) !== JSON.stringify(funcoesNovas),
            mudouValidade: mudouValidadeLancamentos,
            mudouTipoPadrao:
              dadosAnteriores.tipoPadrao !== dadosNovos.tipoPadrao,
          },
          lancamentosAtualizados,
        },
      });

      alert("TREINAMENTO ATUALIZADO COM SUCESSO!");
      limparEdicaoTreinamento();
      await buscarTreinamentosCatalogo();
      if (matrizSelecionada)
        await buscarTreinamentosDaMatriz(matrizSelecionada);
    } catch (error) {
      console.error("Erro ao editar treinamento:", error);
      alert("ERRO AO EDITAR TREINAMENTO.");
    } finally {
      setLoading(false);
    }
  };

  const salvarEdicaoMatriz = async () => {
    if (!podeEditarMatrizes) {
      alert("VOCÊ NÃO TEM PERMISSÃO PARA EDITAR MATRIZES.");
      return;
    }

    if (!matrizSelecionada) {
      alert("SELECIONE UMA MATRIZ.");
      return;
    }

    if (!treinamentoMatriz.id) {
      alert("SELECIONE UM TREINAMENTO DA MATRIZ PARA EDITAR.");
      return;
    }

    const nome = normalizarTexto(treinamentoMatriz.nome);
    const nomeOriginal = normalizarTexto(treinamentoMatriz.nomeOriginal);
    const funcoesNovas = funcoesTreinamentoMatriz.map((item) => ({
      funcao: normalizarTexto(item.funcao),
      tipo: normalizarTexto(item.tipo || treinamentoMatriz.tipoPadrao),
    }));
    const funcoesAntigas = treinamentoMatriz.funcoesOriginais || [];
    const agora = new Date().toISOString();
    const responsavel = responsavelSistema();

    const valido = validarTreinamento({
      nome,
      validade: treinamentoMatriz.validade,
      possuiVencimento: treinamentoMatriz.possuiVencimento,
      funcoes: funcoesNovas,
      matrizes: [matrizSelecionada],
    });

    if (!valido) return;

    try {
      setLoading(true);

      if (nome !== nomeOriginal) {
        const novoRef = doc(
          db,
          "matrizes",
          matrizSelecionada,
          "treinamentos",
          nome,
        );
        const novoDoc = await getDoc(novoRef);

        if (novoDoc.exists()) {
          alert("JÁ EXISTE UM TREINAMENTO COM ESSE NOME NESTA MATRIZ.");
          return;
        }
      }

      const dadosAnteriores = {
        nome: nomeOriginal,
        validade: treinamentoMatriz.possuiVencimentoOriginal
          ? String(treinamentoMatriz.validadeOriginal)
          : "",
        possuiVencimento: Boolean(treinamentoMatriz.possuiVencimentoOriginal),
        tipoPadrao: normalizarTexto(treinamentoMatriz.tipoPadrao),
        situacao: treinamentoMatriz.ativo ? "ATIVO" : "DESATIVADO",
        funcoesVinculadas: funcoesAntigas,
      };

      const dadosNovos = montarDadosTreinamento({
        nome,
        tipoPadrao: treinamentoMatriz.tipoPadrao,
        validade: treinamentoMatriz.validade,
        possuiVencimento: treinamentoMatriz.possuiVencimento,
        funcoes: funcoesNovas,
        ativo: treinamentoMatriz.situacao === "ATIVO",
        extras: {
          atualizadoPor: responsavel.nome,
          atualizadoPorId: responsavel.id,
          dataAtualizacao: agora,
        },
      });

      await deleteDoc(
        doc(db, "matrizes", matrizSelecionada, "treinamentos", nomeOriginal),
      );
      await removerTreinamentoDasFuncoesMatriz({
        matrizId: matrizSelecionada,
        nomeTreinamento: nomeOriginal,
        funcoes: funcoesAntigas,
      });

      await setDoc(
        doc(db, "matrizes", matrizSelecionada, "treinamentos", nome),
        dadosNovos,
      );
      await gravarTreinamentoNasFuncoesMatriz({
        matrizId: matrizSelecionada,
        dadosTreinamento: dadosNovos,
        responsavel,
        agora,
        modo: "edicao",
      });

      const mudouValidadeLancamentos =
        dadosAnteriores.validade !== dadosNovos.validade ||
        dadosAnteriores.possuiVencimento !== dadosNovos.possuiVencimento;

      const lancamentosAtualizados =
        await atualizarValidadeLancamentosExistentes({
          nomeTreinamento: nomeOriginal,
          dadosTreinamento: dadosNovos,
          responsavel,
          agora,
        });

      if (lancamentosAtualizados > 0) {
        limparCacheValidadeTreinamentos();
      }

      await criarAuditoria({
        acao: "EDICAO_MATRIZ",
        entidade: "MATRIZ",
        entidadeId: matrizSelecionada,
        detalhes: {
          matriz: matrizSelecionada,
          dadosAnteriores,
          dadosNovos,
          alteracoes: {
            mudouNome: nomeOriginal !== nome,
            mudouFuncoes:
              JSON.stringify(funcoesAntigas) !== JSON.stringify(funcoesNovas),
            mudouSituacao: dadosAnteriores.situacao !== dadosNovos.situacao,
            mudouValidade: mudouValidadeLancamentos,
            mudouTipoPadrao:
              dadosAnteriores.tipoPadrao !== dadosNovos.tipoPadrao,
          },
          lancamentosAtualizados,
        },
      });

      alert("MATRIZ ATUALIZADA COM SUCESSO!");
      limparTreinamentoMatriz();
      await buscarTreinamentosDaMatriz(matrizSelecionada);
      await buscarTreinamentosCatalogo();
    } catch (error) {
      console.error("Erro ao salvar edição da matriz:", error);
      alert("ERRO AO SALVAR EDIÇÃO DA MATRIZ.");
    } finally {
      setLoading(false);
    }
  };

  const voltarMain = () => navigate("/main");

  const renderListaFuncoes = ({ lista, setLista }) => (
    <div className="lista-funcoes-wrapper">
      <div className="lista-funcoes-cabecalho">
        <h2>FUNÇÕES VINCULADAS AO TREINAMENTO</h2>
      </div>

      <div className="lista-funcoes-scroll">
        {lista.length > 0 ? (
          <div className="lista-funcoes-treinamento">
            {lista.map((item, index) => (
              <div key={`${item.funcao}-${index}`} className="funcao-chip">
                <span className="funcao-chip-nome">{item.funcao}</span>

                <select
                  value={item.tipo}
                  onChange={(e) =>
                    alterarTipoFuncao(setLista, index, e.target.value)
                  }
                >
                  <option value="OBRIGATORIO">OBRIGATÓRIO</option>
                  <option value="EVENTUAL">EVENTUAL</option>
                </select>

                <button
                  type="button"
                  onClick={() => removerFuncao(setLista, index)}
                >
                  REMOVER
                </button>
              </div>
            ))}
          </div>
        ) : (
          <div className="mensagem-sem-funcoes">
            NENHUMA FUNÇÃO ADICIONADA AINDA.
          </div>
        )}
      </div>
    </div>
  );

  if (carregandoConfiguracoes) {
    return (
      <div className="container-inclusao">
        <div className="container-inclusao-box">
          <div className="mensagem-carregando-inclusao">
            CARREGANDO CONFIGURAÇÕES...
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container-inclusao">
      <div className="container-inclusao-box">
        <div className="topo-inclusao">
          <button
            className={abaAtiva === "colaborador" ? "aba ativa" : "aba"}
            onClick={() => setAbaAtiva("colaborador")}
          >
            INCLUIR COLABORADOR
          </button>

          {podeCadastrarTreinamento && (
            <button
              className={abaAtiva === "treinamento" ? "aba ativa" : "aba"}
              onClick={() => setAbaAtiva("treinamento")}
            >
              INCLUIR TREINAMENTO
            </button>
          )}

          {podeEditarMatrizes && (
            <button
              className={abaAtiva === "matrizes" ? "aba ativa" : "aba"}
              onClick={() => setAbaAtiva("matrizes")}
            >
              EDITAR MATRIZES
            </button>
          )}
        </div>

        <div className="usuario-logado-inclusao">
          <span>USUÁRIO LOGADO</span>
          <p>{normalizarTexto(usuarioLogado?.nome || "NÃO INFORMADO")}</p>
        </div>

        {abaAtiva === "colaborador" && (
          <div className="form-inclusao">
            <h1>CADASTRO DE COLABORADOR</h1>

            <input
              type="text"
              name="nome"
              placeholder="NOME DO COLABORADOR"
              value={colaborador.nome}
              onChange={handleColaboradorChange}
            />

            <div className="linha-dupla-inclusao">
              <input
                type="text"
                name="cpf"
                placeholder="CPF"
                value={colaborador.cpf}
                onChange={handleCpfChange}
                inputMode="numeric"
                maxLength="14"
              />

              <select
                name="obra"
                value={colaborador.obra}
                onChange={handleColaboradorChange}
              >
                <option value="">SELECIONE A OBRA</option>
                {obrasDisponiveis.map((obra) => (
                  <option key={obra.id} value={obra.nome}>
                    {obra.nome}
                  </option>
                ))}
              </select>
            </div>

            <div className="campo-funcao-inclusao">
              <input
                type="text"
                name="funcao"
                placeholder="DIGITE A FUNÇÃO"
                value={colaborador.funcao}
                onChange={handleColaboradorChange}
                onFocus={() => setMostrarSugestoesFuncao(true)}
                onBlur={() =>
                  setTimeout(() => setMostrarSugestoesFuncao(false), 150)
                }
              />

              {mostrarSugestoesFuncao && sugestoesFuncoes.length > 0 && (
                <div className="dropdown-funcoes-inclusao">
                  {sugestoesFuncoes.map((funcao) => (
                    <div
                      key={funcao.id}
                      className="item-funcao-inclusao"
                      onMouseDown={() => selecionarFuncao(funcao.nome)}
                    >
                      {funcao.nome}
                    </div>
                  ))}
                </div>
              )}
            </div>

            <button
              className="btn-salvar-inclusao"
              onClick={cadastrarColaborador}
              disabled={loading}
            >
              {loading ? "SALVANDO..." : "SALVAR COLABORADOR"}
            </button>

            <div className="bloco-situacao-colaborador">
              <h2>EDITAR COLABORADOR</h2>

              <div className="campo-funcao-inclusao">
                <input
                  type="text"
                  name="busca"
                  placeholder="BUSQUE POR NOME OU CPF"
                  autoComplete="off"
                  value={edicaoColaborador.busca}
                  onChange={handleEdicaoColaboradorChange}
                  onFocus={() => setMostrarSugestoesColaboradorEdicao(true)}
                  onBlur={() =>
                    setTimeout(
                      () => setMostrarSugestoesColaboradorEdicao(false),
                      150,
                    )
                  }
                />

                {mostrarSugestoesColaboradorEdicao &&
                  sugestoesColaboradorEdicao.length > 0 && (
                    <div className="dropdown-funcoes-inclusao">
                      {sugestoesColaboradorEdicao.map((item) => (
                        <div
                          key={item.id}
                          className="item-funcao-inclusao"
                          onMouseDown={() => selecionarColaboradorEdicao(item)}
                        >
                          {item.nome} - {formatarCPF(item.cpf || "")}
                        </div>
                      ))}
                    </div>
                  )}
              </div>

              <input
                type="text"
                name="nome"
                placeholder="NOME DO COLABORADOR"
                value={edicaoColaborador.nome}
                onChange={handleEdicaoColaboradorChange}
              />

              <div className="linha-dupla-inclusao">
                <input
                  type="text"
                  name="cpf"
                  placeholder="CPF"
                  value={edicaoColaborador.cpf}
                  readOnly
                />

                <select
                  name="obra"
                  value={edicaoColaborador.obra}
                  onChange={handleEdicaoColaboradorChange}
                >
                  <option value="">SELECIONE A OBRA</option>
                  {obrasDisponiveis.map((obra) => (
                    <option key={obra.id} value={obra.nome}>
                      {obra.nome}
                    </option>
                  ))}
                </select>
              </div>

              <div className="campo-funcao-inclusao">
                <input
                  type="text"
                  name="funcao"
                  placeholder="FUNÇÃO"
                  value={edicaoColaborador.funcao}
                  onChange={handleEdicaoColaboradorChange}
                  onFocus={() => setMostrarSugestoesFuncaoEdicao(true)}
                  onBlur={() =>
                    setTimeout(
                      () => setMostrarSugestoesFuncaoEdicao(false),
                      150,
                    )
                  }
                />

                {mostrarSugestoesFuncaoEdicao &&
                  sugestoesFuncoesEdicao.length > 0 && (
                    <div className="dropdown-funcoes-inclusao">
                      {sugestoesFuncoesEdicao.map((funcao) => (
                        <div
                          key={funcao.id}
                          className="item-funcao-inclusao"
                          onMouseDown={() =>
                            selecionarFuncaoEdicao(funcao.nome)
                          }
                        >
                          {funcao.nome}
                        </div>
                      ))}
                    </div>
                  )}
              </div>

              <button
                className="btn-salvar-inclusao"
                onClick={editarColaborador}
                disabled={loading}
              >
                {loading ? "SALVANDO..." : "SALVAR EDIÇÃO DO COLABORADOR"}
              </button>
            </div>

            <div className="bloco-situacao-colaborador">
              <h2>DESATIVAR / REATIVAR COLABORADOR</h2>

              <div className="campo-funcao-inclusao">
                <input
                  type="text"
                  name="busca"
                  placeholder="BUSQUE POR NOME OU CPF"
                  autoComplete="off"
                  value={controleSituacao.busca}
                  onChange={handleControleSituacaoChange}
                  onFocus={() => setMostrarSugestoesColaboradorSituacao(true)}
                  onBlur={() =>
                    setTimeout(
                      () => setMostrarSugestoesColaboradorSituacao(false),
                      150,
                    )
                  }
                />

                {mostrarSugestoesColaboradorSituacao &&
                  sugestoesColaboradorSituacao.length > 0 && (
                    <div className="dropdown-funcoes-inclusao">
                      {sugestoesColaboradorSituacao.map((item) => (
                        <div
                          key={item.id}
                          className="item-funcao-inclusao"
                          onMouseDown={() =>
                            selecionarColaboradorSituacao(item)
                          }
                        >
                          {item.nome} - {formatarCPF(item.cpf || "")}
                        </div>
                      ))}
                    </div>
                  )}
              </div>

              <div className="painel-colaborador-situacao">
                <div className="info-situacao-item">
                  <span>NOME</span>
                  <p>{controleSituacao.nome || "-"}</p>
                </div>
                <div className="info-situacao-item">
                  <span>CPF</span>
                  <p>{controleSituacao.cpf || "-"}</p>
                </div>
                <div className="info-situacao-item">
                  <span>FUNÇÃO</span>
                  <p>{controleSituacao.funcao || "-"}</p>
                </div>
                <div className="info-situacao-item">
                  <span>OBRA</span>
                  <p>{controleSituacao.obra || "-"}</p>
                </div>
              </div>

              <div className="linha-dupla-inclusao">
                <select
                  name="situacao"
                  value={controleSituacao.situacao}
                  onChange={handleControleSituacaoChange}
                >
                  <option value="ATIVO">ATIVO</option>
                  <option value="DESATIVADO">DESATIVADO</option>
                </select>

                <button
                  className="btn-salvar-inclusao btn-situacao-colaborador"
                  onClick={atualizarSituacaoColaborador}
                  disabled={loading}
                >
                  {loading ? "SALVANDO..." : "ATUALIZAR SITUAÇÃO"}
                </button>
              </div>
            </div>
          </div>
        )}

        {abaAtiva === "treinamento" && podeCadastrarTreinamento && (
          <div className="form-inclusao form-inclusao-treinamento">
            <h1>CADASTRO DE TREINAMENTO</h1>

            <input
              type="text"
              name="nome"
              placeholder="NOME DO TREINAMENTO"
              value={treinamento.nome}
              onChange={handleTreinamentoChange}
            />

            <div className="lista-funcoes-wrapper">
              <div className="lista-funcoes-cabecalho">
                <h2>MATRIZES ONDE ESTE TREINAMENTO SERÁ APLICADO</h2>
              </div>
              <div className="lista-funcoes-treinamento lista-checks-matrizes">
                {matrizesDisponiveis.map((matriz) => {
                  const matrizAtualEhAtlas =
                    ehMatrizAtlas(matriz.id) || ehMatrizAtlas(matriz.nome);
                  const atlasSelecionada =
                    treinamento.matrizesSelecionadas.some(ehMatrizAtlas);
                  const matrizNaoAtlasSelecionada =
                    treinamento.matrizesSelecionadas.some(
                      (matrizId) => !ehMatrizAtlas(matrizId),
                    );

                  const desabilitarMatriz =
                    (atlasSelecionada && !matrizAtualEhAtlas) ||
                    (matrizNaoAtlasSelecionada && matrizAtualEhAtlas);

                  return (
                    <label
                      key={matriz.id}
                      className={`check-inclusao ${
                        desabilitarMatriz ? "check-inclusao-desabilitado" : ""
                      }`}
                    >
                      <input
                        type="checkbox"
                        name="matrizesSelecionadas"
                        value={matriz.id}
                        checked={treinamento.matrizesSelecionadas.includes(
                          matriz.id,
                        )}
                        disabled={desabilitarMatriz}
                        onChange={handleTreinamentoChange}
                      />
                      <span>{matriz.nome || matriz.id}</span>
                    </label>
                  );
                })}
              </div>
            </div>

            <div className="acoes-funcoes-inclusao acoes-funcoes-inclusao-topo">
              <button
                type="button"
                className="btn-secundario-inclusao"
                onClick={selecionarTodasFuncoesCriacao}
              >
                MARCAR TODAS AS FUNÇÕES
              </button>
              <button
                type="button"
                className="btn-secundario-inclusao"
                onClick={() => setFuncoesTreinamento([])}
              >
                DESMARCAR TODAS
              </button>
              <select
                name="tipoPadrao"
                value={treinamento.tipoPadrao}
                onChange={handleTreinamentoChange}
                className="select-acao-inclusao"
              >
                {TIPOS_TREINAMENTO.map((tipo) => (
                  <option key={tipo} value={tipo}>
                    TIPO PADRÃO: {tipo}
                  </option>
                ))}
              </select>
            </div>

            <div className="linha-check-inclusao">
              <label className="check-inclusao">
                <input
                  type="checkbox"
                  name="possuiVencimento"
                  checked={treinamento.possuiVencimento}
                  onChange={handleTreinamentoChange}
                />
                <span>TER VENCIMENTO</span>
              </label>
            </div>

            <div className="campo-funcao-inclusao">
              <input
                type="text"
                name="funcaoBusca"
                placeholder="ADICIONE FUNÇÕES AO TREINAMENTO"
                autoComplete="off"
                value={treinamento.funcaoBusca}
                onChange={handleTreinamentoChange}
                onFocus={() => setMostrarSugestoesFuncaoTreinamento(true)}
                onBlur={() =>
                  setTimeout(
                    () => setMostrarSugestoesFuncaoTreinamento(false),
                    150,
                  )
                }
              />

              {mostrarSugestoesFuncaoTreinamento &&
                sugestoesFuncoesTreinamento.length > 0 && (
                  <div className="dropdown-funcoes-inclusao">
                    {sugestoesFuncoesTreinamento.map((funcao) => (
                      <div
                        key={funcao.id}
                        className="item-funcao-inclusao"
                        onMouseDown={() =>
                          selecionarFuncaoTreinamento(funcao.nome)
                        }
                      >
                        {funcao.nome}
                      </div>
                    ))}
                  </div>
                )}
            </div>

            {treinamento.possuiVencimento && (
              <input
                type="number"
                name="validade"
                placeholder="VALIDADE EM MESES (1 A 60)"
                value={treinamento.validade}
                onChange={handleTreinamentoChange}
                min="1"
                max="60"
              />
            )}

            {renderListaFuncoes({
              lista: funcoesTreinamento,
              setLista: setFuncoesTreinamento,
            })}

            <button
              className="btn-salvar-inclusao"
              onClick={cadastrarTreinamento}
              disabled={loading}
            >
              {loading ? "SALVANDO..." : "SALVAR TREINAMENTO"}
            </button>

            <div className="bloco-situacao-colaborador">
              <h2>EDITAR TREINAMENTO</h2>

              <div className="campo-funcao-inclusao">
                <input
                  type="text"
                  name="busca"
                  placeholder="BUSQUE O TREINAMENTO"
                  autoComplete="off"
                  value={edicaoTreinamento.busca}
                  onChange={handleTreinamentoEdicaoChange}
                  onFocus={() => setMostrarSugestoesTreinamentoEdicao(true)}
                  onBlur={() =>
                    setTimeout(
                      () => setMostrarSugestoesTreinamentoEdicao(false),
                      150,
                    )
                  }
                />

                {mostrarSugestoesTreinamentoEdicao &&
                  sugestoesTreinamentoEdicao.length > 0 && (
                    <div className="dropdown-funcoes-inclusao">
                      {sugestoesTreinamentoEdicao.map((item) => (
                        <div
                          key={item.id}
                          className="item-funcao-inclusao"
                          onMouseDown={() => selecionarTreinamentoEdicao(item)}
                        >
                          {item.nome}
                        </div>
                      ))}
                    </div>
                  )}
              </div>

              <input
                type="text"
                name="nome"
                placeholder="NOME DO TREINAMENTO"
                value={edicaoTreinamento.nome}
                onChange={handleTreinamentoEdicaoChange}
              />

              <div className="lista-funcoes-wrapper">
                <div className="lista-funcoes-cabecalho">
                  <h2>MATRIZES VINCULADAS</h2>
                </div>
                <div className="lista-funcoes-treinamento lista-checks-matrizes">
                  {matrizesDisponiveis.map((matriz) => {
                    const matrizAtualEhAtlas =
                      ehMatrizAtlas(matriz.id) || ehMatrizAtlas(matriz.nome);
                    const atlasSelecionada =
                      edicaoTreinamento.matrizesSelecionadas.some(
                        ehMatrizAtlas,
                      );
                    const matrizNaoAtlasSelecionada =
                      edicaoTreinamento.matrizesSelecionadas.some(
                        (matrizId) => !ehMatrizAtlas(matrizId),
                      );

                    const desabilitarMatriz =
                      (atlasSelecionada && !matrizAtualEhAtlas) ||
                      (matrizNaoAtlasSelecionada && matrizAtualEhAtlas);

                    return (
                      <label
                        key={matriz.id}
                        className={`check-inclusao ${
                          desabilitarMatriz ? "check-inclusao-desabilitado" : ""
                        }`}
                      >
                        <input
                          type="checkbox"
                          name="matrizesSelecionadas"
                          value={matriz.id}
                          checked={edicaoTreinamento.matrizesSelecionadas.includes(
                            matriz.id,
                          )}
                          disabled={desabilitarMatriz}
                          onChange={handleTreinamentoEdicaoChange}
                        />
                        <span>{matriz.nome || matriz.id}</span>
                      </label>
                    );
                  })}
                </div>
              </div>

              <div className="acoes-funcoes-inclusao acoes-funcoes-inclusao-topo">
                <button
                  type="button"
                  className="btn-secundario-inclusao"
                  onClick={selecionarTodasFuncoesEdicao}
                >
                  MARCAR TODAS AS FUNÇÕES
                </button>
                <button
                  type="button"
                  className="btn-secundario-inclusao"
                  onClick={() => setFuncoesTreinamentoEdicao([])}
                >
                  DESMARCAR TODAS
                </button>
                <select
                  name="tipoPadrao"
                  value={edicaoTreinamento.tipoPadrao}
                  onChange={handleTreinamentoEdicaoChange}
                  className="select-acao-inclusao"
                >
                  {TIPOS_TREINAMENTO.map((tipo) => (
                    <option key={tipo} value={tipo}>
                      TIPO PADRÃO: {tipo}
                    </option>
                  ))}
                </select>
              </div>

              <div className="linha-check-inclusao">
                <label className="check-inclusao">
                  <input
                    type="checkbox"
                    name="possuiVencimento"
                    checked={edicaoTreinamento.possuiVencimento}
                    onChange={handleTreinamentoEdicaoChange}
                  />
                  <span>TER VENCIMENTO</span>
                </label>
              </div>

              <div className="campo-funcao-inclusao">
                <input
                  type="text"
                  name="funcaoBusca"
                  placeholder="ADICIONE FUNÇÕES AO TREINAMENTO"
                  autoComplete="off"
                  value={edicaoTreinamento.funcaoBusca}
                  onChange={handleTreinamentoEdicaoChange}
                  onFocus={() =>
                    setMostrarSugestoesFuncaoTreinamentoEdicao(true)
                  }
                  onBlur={() =>
                    setTimeout(
                      () => setMostrarSugestoesFuncaoTreinamentoEdicao(false),
                      150,
                    )
                  }
                />

                {mostrarSugestoesFuncaoTreinamentoEdicao &&
                  sugestoesFuncoesTreinamentoEdicao.length > 0 && (
                    <div className="dropdown-funcoes-inclusao">
                      {sugestoesFuncoesTreinamentoEdicao.map((funcao) => (
                        <div
                          key={funcao.id}
                          className="item-funcao-inclusao"
                          onMouseDown={() =>
                            selecionarFuncaoTreinamentoEdicao(funcao.nome)
                          }
                        >
                          {funcao.nome}
                        </div>
                      ))}
                    </div>
                  )}
              </div>

              {edicaoTreinamento.possuiVencimento && (
                <input
                  type="number"
                  name="validade"
                  placeholder="VALIDADE EM MESES (1 A 60)"
                  value={edicaoTreinamento.validade}
                  onChange={handleTreinamentoEdicaoChange}
                  min="1"
                  max="60"
                />
              )}

              {renderListaFuncoes({
                lista: funcoesTreinamentoEdicao,
                setLista: setFuncoesTreinamentoEdicao,
              })}

              <button
                className="btn-salvar-inclusao"
                onClick={editarTreinamento}
                disabled={loading}
              >
                {loading ? "SALVANDO..." : "SALVAR EDIÇÃO DO TREINAMENTO"}
              </button>
            </div>
          </div>
        )}

        {abaAtiva === "matrizes" && podeEditarMatrizes && (
          <div className="form-inclusao form-inclusao-treinamento">
            <h1>EDITAR MATRIZES</h1>

            <select
              value={matrizSelecionada}
              onChange={(e) => setMatrizSelecionada(e.target.value)}
            >
              <option value="">SELECIONE A MATRIZ</option>
              {matrizesDisponiveis.map((matriz) => (
                <option key={matriz.id} value={matriz.id}>
                  {matriz.nome || matriz.id}
                </option>
              ))}
            </select>

            {matrizSelecionada && (
              <div className="bloco-situacao-colaborador bloco-editor-matriz">
                <h2>TREINAMENTOS DA MATRIZ</h2>

                {treinamentosMatriz.length > 0 ? (
                  <div className="grade-treinamentos-matriz">
                    {treinamentosMatriz.map((item) => (
                      <button
                        type="button"
                        key={item.id}
                        className={
                          treinamentoMatriz.nomeOriginal === item.nome
                            ? "card-treinamento-matriz ativo"
                            : "card-treinamento-matriz"
                        }
                        onClick={() => selecionarTreinamentoDaMatriz(item)}
                      >
                        <strong>{item.nome}</strong>
                        <span>{item.situacao}</span>
                      </button>
                    ))}
                  </div>
                ) : (
                  <div className="mensagem-sem-funcoes">
                    NENHUM TREINAMENTO ENCONTRADO NESTA MATRIZ.
                  </div>
                )}
              </div>
            )}

            {treinamentoMatriz.id && (
              <div className="bloco-situacao-colaborador bloco-editor-matriz">
                <h2>EDITAR TREINAMENTO DA MATRIZ</h2>

                <input
                  type="text"
                  name="nome"
                  placeholder="NOME DO TREINAMENTO"
                  value={treinamentoMatriz.nome}
                  onChange={handleTreinamentoMatrizChange}
                />

                <div className="linha-dupla-inclusao">
                  <select
                    name="tipoPadrao"
                    value={treinamentoMatriz.tipoPadrao}
                    onChange={handleTreinamentoMatrizChange}
                  >
                    {TIPOS_TREINAMENTO.map((tipo) => (
                      <option key={tipo} value={tipo}>
                        TIPO PADRÃO: {tipo}
                      </option>
                    ))}
                  </select>

                  <select
                    name="situacao"
                    value={treinamentoMatriz.situacao}
                    onChange={handleTreinamentoMatrizChange}
                  >
                    {SITUACOES_TREINAMENTO.map((situacao) => (
                      <option key={situacao} value={situacao}>
                        {situacao}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="acoes-funcoes-inclusao acoes-funcoes-inclusao-topo">
                  <button
                    type="button"
                    className="btn-secundario-inclusao"
                    onClick={selecionarTodasFuncoesMatriz}
                  >
                    MARCAR TODAS AS FUNÇÕES
                  </button>
                  <button
                    type="button"
                    className="btn-secundario-inclusao"
                    onClick={() => setFuncoesTreinamentoMatriz([])}
                  >
                    DESMARCAR TODAS
                  </button>
                </div>

                <div className="linha-check-inclusao">
                  <label className="check-inclusao">
                    <input
                      type="checkbox"
                      name="possuiVencimento"
                      checked={treinamentoMatriz.possuiVencimento}
                      onChange={handleTreinamentoMatrizChange}
                    />
                    <span>TER VENCIMENTO</span>
                  </label>
                </div>

                <div className="campo-funcao-inclusao">
                  <input
                    type="text"
                    name="funcaoBusca"
                    placeholder="ADICIONE FUNÇÕES AO TREINAMENTO"
                    autoComplete="off"
                    value={treinamentoMatriz.funcaoBusca}
                    onChange={handleTreinamentoMatrizChange}
                    onFocus={() => setMostrarSugestoesFuncaoMatriz(true)}
                    onBlur={() =>
                      setTimeout(
                        () => setMostrarSugestoesFuncaoMatriz(false),
                        150,
                      )
                    }
                  />

                  {mostrarSugestoesFuncaoMatriz &&
                    sugestoesFuncoesMatriz.length > 0 && (
                      <div className="dropdown-funcoes-inclusao">
                        {sugestoesFuncoesMatriz.map((funcao) => (
                          <div
                            key={funcao.id}
                            className="item-funcao-inclusao"
                            onMouseDown={() =>
                              selecionarFuncaoMatriz(funcao.nome)
                            }
                          >
                            {funcao.nome}
                          </div>
                        ))}
                      </div>
                    )}
                </div>

                {treinamentoMatriz.possuiVencimento && (
                  <input
                    type="number"
                    name="validade"
                    placeholder="VALIDADE EM MESES (1 A 60)"
                    value={treinamentoMatriz.validade}
                    onChange={handleTreinamentoMatrizChange}
                    min="1"
                    max="60"
                  />
                )}

                {renderListaFuncoes({
                  lista: funcoesTreinamentoMatriz,
                  setLista: setFuncoesTreinamentoMatriz,
                })}

                <button
                  className="btn-salvar-inclusao"
                  onClick={salvarEdicaoMatriz}
                  disabled={loading}
                >
                  {loading ? "SALVANDO..." : "SALVAR ALTERAÇÕES DA MATRIZ"}
                </button>
              </div>
            )}
          </div>
        )}
      </div>

      <div className="footer-inclusao">
        <img
          onClick={voltarMain}
          className="icon-home-inclusao"
          src={turn}
          alt="Voltar para a tela principal"
        />
      </div>
    </div>
  );
};

export default Inclusao;
